import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IAddClosingYear, IClosingYear } from '../models/closing-year.models';
import { ClosingYearLockValue } from '../models/closing-year.static';

@Injectable({
  providedIn: 'root'
})
export class ClosingYearService {

  constructor(private http: HttpClient,) { }


  addClosingYear(data: IClosingYear[]) {
    return this.http.post<any>(`${environment.financeURl}ClosingYear`, data);
  }

  editClosingYear(data: IClosingYear) {
    return this.http.put<any>(`${environment.financeURl}ClosingYear`, data);
  }

  deleteClosingYear(id: number) {
    return this.http.delete<any>(`${environment.financeURl}ClosingYear/${id}`);
  }

  getClosingYear(year: number, monthId: number) {
    return this.http.get<any>(`${environment.financeURl}ClosingYear`, { params: { year: year, monthId: monthId } });
  }

  getAllClosingYear(pageSize: number, pageNumber: number, searchValue?: string, seachFields?: string, options?: any) {
    let url = environment.financeURl + "ClosingYear?pageNumber=" + pageNumber + "&pageSize=" + pageSize;
    if (options?.sort) {
      url = `${url}&SortBy=${options.sort.SortBy}&IsAscending=${options.sort.IsAscending}`;
    }

    if (!options || !options.sort) {
      url = `${url}&SortBy=createdDate&IsAscending=false`;
    }

    if (searchValue) {
      url = `${url}&SearchValue=${searchValue}&SearchColumns=${seachFields}`;
    }
    return this.http.get<any>(url, {
      observe: 'response'
    })
      .toPromise()
      .then(res =>
      ({
        closingYears: res.body,
        headers: JSON.parse(res.headers.get('x-pagination'))
      })
      );
  }

  getClosingStatement(year: number, month: number) {
    return this.http.get<any>(`${environment.financeURl}ClosingYear/ClosingYearLock?year=${year}&monthId=${month}`);
  }
  prepareClosingYearsLock(closingYears: IAddClosingYear): IAddClosingYear {
    return {
      ...closingYears,
      lockAR: closingYears?.closingYearLocks?.find(x => x.lockName == ClosingYearLockValue.lockAR)?.lockValue ?? false,
      lockAP: closingYears?.closingYearLocks?.find(x => x.lockName == ClosingYearLockValue.lockAP)?.lockValue ?? false,
      lockGL: closingYears?.closingYearLocks?.find(x => x.lockName == ClosingYearLockValue.lockGL)?.lockValue ?? false,
      lockPeriodClose: closingYears?.closingYearLocks?.find(x => x.lockName == ClosingYearLockValue.lockPeriodClose)?.lockValue ?? false,
      excludeOthers: closingYears?.closingYearLocks?.find(x => x.lockName == ClosingYearLockValue.excludeOthers)?.lockValue ?? true,
    } ?? null;
  }
}
